import React from 'react';
import ReactDOM from 'react-dom/client';
import App from "./app"
import './style.css';
import { BrowserRouter } from 'react-router-dom';


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(

<div>
<BrowserRouter>
<App/>
</BrowserRouter>


</div>


)




